<template>
  <div ref="container">
    <a-modal :title="title" width="95%" :visible="visible" :maskStyle="{ 'top': '93px', 'left': '154px' }"
             @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 80%;">
      <a-table :dataSource="dataSource" :pagination="pagination" :columns="columns" :loading="loading">
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { accumulategetByNumber, accumulategetByOutNumberNew } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'UDIOutlistDialog',
  mixins: [JeecgListMixin],
  data () {
    return {
      title: '详情',
      visible: false,
      model: {},
      pagination: {
        current: 1,
        pageSize: 10,
        onChange: this.handlePageChange,
      },
      dataSource: [],
      disableMixinCreated: true,
      url: {
        list: '/report/outStorageDetail',
      },
      loading: false,
      columns: [
        {
          title: '产品名称',
          dataIndex: 'materialName',
          width: 150,
          align: "center"
        },
        {
          title: '规格型号',
          dataIndex: 'standard',
          width: 150,
          align: "center"
        },
        { title: '批次号', dataIndex: 'batchNumber', width: 80, align: "center" },
        { title: '产品数量', dataIndex: 'quantity', width: 80,align: "center" },
        {
          title: '包装数量',
          dataIndex: 'quantitySpec',
          width: 150,
          align: "center"
        },
      ],
    }
  },
  created () { },
  methods: {
    async add (e, type) {
      this.visible = true
      this.pagination.current = 1
      this.topQueryParam.headerId = e.id
      this.loadData(1)
    },
    close () {
      this.$emit('close')
      this.visible = false
    },
    handleOk () {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel () {
      this.close()
    },
    handlePageChange (page, pageSize) {
      console.log(page, 'page')
      console.log(pageSize, 'pageSize')
      this.pagination.current = page
    },
  },
}
</script>
<style scoped></style>